export default __webpack_public_path__ + "static/media/NotoSans-Thin.ccfd5564.otf";